<template>
  <div class="activity-center-header">
    <h2 class="activity-center-header__title text-uppercase">Activity Center</h2>
    <div class="activity-center-header__actions">
      <mi-btn
        flat
        dense
        icon-right="settings"
        icon-right-size="20px"
        class="activity-center-header__preferences-btn"
        @click="$emit('open:preferences')"
      >
        <span class="activity-center-header__preferences-label">Preferences</span>
      </mi-btn>
      <mi-btn
        flat
        dense
        icon-type
        icon="close"
        icon-size="20px"
        class="activity-center-header__close-btn"
        @click="$emit('close')"
      ></mi-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ActivityCenterHeader',
    emits: ['close', 'open:preferences']
  }
</script>

<style lang="scss" scoped>
  // stylelint-disable declaration-no-important
  .activity-center-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 32px;
    background-color: $mi-anthracite-50;

    &__title {
      margin: 0;
      font-family: $mi-typography-font-family-condensed;
      font-weight: 700;
      font-size: 28px;
      line-height: 42px;
      color: $mi-anthracite-800;
    }

    &__actions {
      display: flex;
      align-items: center;
      gap: 16px;

      ::v-deep(.q-focus-helper) {
        display: none !important;
      }
    }

    &__preferences-btn {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &__close-btn,
    &__preferences-btn {
      ::v-deep(.q-btn__content) {
        gap: 8px;
      }
    }

    &__preferences-label {
      font-family: $mi-typography-font-family-condensed;
      font-weight: 700;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0;
      text-align: center;
      color: $mi-anthracite-800;
    }
  }

  ::v-deep(.activity-center-header__actions .mi-btn.q-btn.q-btn--flat:hover) {
    background-color: transparent !important;
  }

  ::v-deep(.activity-center-header__actions .mi-btn.q-btn) {
    &:before,
    &:after {
      display: none !important;
    }

    .q-ripple {
      display: none !important;
    }

    .q-focus-helper {
      display: none !important;
    }

    .q-hoverable:hover > .q-focus-helper {
      opacity: 0 !important;
    }

    .mi-icon {
      opacity: 1 !important;
      color: $mi-anthracite-800 !important;
    }

    &:hover {
      background-color: transparent !important;
      color: $mi-anthracite-800 !important;

      .mi-icon {
        opacity: 1 !important;
        color: $mi-anthracite-800 !important;
      }
    }
  }
</style>
